import { DisclaimerTooltip } from '../../../../common/disclaimer-tooltip/disclaimer-tooltip';

export const FeatureRibbonTooltip: React.FC<{
    superscriptText: string;
    tooltipText: string;
}> = props => {
    return (
        <DisclaimerTooltip
            disclaimer={props.tooltipText}
            symbol={props.superscriptText}
        />
    );
};
